/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadmitToFacilityRequest
 */
export interface ReadmitToFacilityRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ReadmitToFacilityRequest
     */
    hospitalized_lead_ids: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ReadmitToFacilityRequest
     */
    new_lead_id: string;
    /**
     * 
     * @type {string}
     * @memberof ReadmitToFacilityRequest
     */
    move_out_date: string;
    /**
     * 
     * @type {string}
     * @memberof ReadmitToFacilityRequest
     */
    move_out_comment?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadmitToFacilityRequest
     */
    move_in_date: string;
    /**
     * 
     * @type {string}
     * @memberof ReadmitToFacilityRequest
     */
    scheduled_move_out_date?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadmitToFacilityRequest
     */
    bed_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadmitToFacilityRequest
     */
    stay_type: ReadmitToFacilityRequestStayTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ReadmitToFacilityRequest
     */
    comment?: string;
}


/**
 * @export
 */
export const ReadmitToFacilityRequestStayTypeEnum = {
    LongTerm: 'Long-Term',
    ShortTerm: 'Short-Term'
} as const;
export type ReadmitToFacilityRequestStayTypeEnum = typeof ReadmitToFacilityRequestStayTypeEnum[keyof typeof ReadmitToFacilityRequestStayTypeEnum];


/**
 * Check if a given object implements the ReadmitToFacilityRequest interface.
 */
export function instanceOfReadmitToFacilityRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "hospitalized_lead_ids" in value;
    isInstance = isInstance && "new_lead_id" in value;
    isInstance = isInstance && "move_out_date" in value;
    isInstance = isInstance && "move_in_date" in value;
    isInstance = isInstance && "stay_type" in value;

    return isInstance;
}

export function ReadmitToFacilityRequestFromJSON(json: any): ReadmitToFacilityRequest {
    return ReadmitToFacilityRequestFromJSONTyped(json, false);
}

export function ReadmitToFacilityRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadmitToFacilityRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'hospitalized_lead_ids': json['hospitalized_lead_ids'],
        'new_lead_id': json['new_lead_id'],
        'move_out_date': json['move_out_date'],
        'move_out_comment': !exists(json, 'move_out_comment') ? undefined : json['move_out_comment'],
        'move_in_date': json['move_in_date'],
        'scheduled_move_out_date': !exists(json, 'scheduled_move_out_date') ? undefined : json['scheduled_move_out_date'],
        'bed_id': !exists(json, 'bed_id') ? undefined : json['bed_id'],
        'stay_type': json['stay_type'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
    };
}

export function ReadmitToFacilityRequestToJSON(value?: ReadmitToFacilityRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'hospitalized_lead_ids': value.hospitalized_lead_ids,
        'new_lead_id': value.new_lead_id,
        'move_out_date': value.move_out_date,
        'move_out_comment': value.move_out_comment,
        'move_in_date': value.move_in_date,
        'scheduled_move_out_date': value.scheduled_move_out_date,
        'bed_id': value.bed_id,
        'stay_type': value.stay_type,
        'comment': value.comment,
    };
}

